export function getSeparator(locale: string, separatorType: string) {
	const numberWithGroupAndDecimalSeparator = 1000.1;
	return (
		Intl.NumberFormat(locale)
			.formatToParts(numberWithGroupAndDecimalSeparator)
			.find((part) => part.type === separatorType)?.value || '.'
	);
}
